export default __webpack_public_path__ + "locales/children.ky.json";